var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMur1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 250,
    height: 250,
    viewBox: "0 0 250 250",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M108.94 32.74C150.82 50.41 192.68 68.11 234.56 85.78C233.91 110.35 233.29 134.92 232.63 159.49C190.2 140.4 147.76 121.3 105.33 102.2C106.53 79.05 107.74 55.88 108.94 32.74Z",
    fill: "#FEE4E2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M108.94 32.74C150.82 50.41 192.68 68.11 234.56 85.78C233.91 110.35 233.29 134.92 232.63 159.49C195.58 142.97 158.52 126.44 121.46 109.92C117.28 84.19 113.11 58.47 108.94 32.74Z",
    fill: "#B2E8C5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M28.1899 159.78L135.05 217.26L232.63 160.19C195.58 143.43 158.52 126.65 121.46 109.9C90.35 126.54 59.2699 143.17 28.1899 159.79V159.78Z",
    fill: "#29A063"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M222.44 80.6C226.49 82.34 230.51 84.05 234.56 85.78C232.59 106.78 230.61 127.76 228.61 148.76C210.94 159.07 193.08 169.38 175.02 179.68C157.06 189.93 139.19 200.01 121.43 209.93V126.48C155.12 111.19 188.78 95.88 222.44 80.6Z",
    fill: "#F97E73"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M135.05 133.82V217.27C130.51 214.83 125.97 212.39 121.43 209.94V126.49L135.05 133.82Z",
    fill: "#FEE4E2"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M135.05 217.26C167.58 198.24 200.91 178.83 233.43 159.81C234.09 135 233.91 110.57 234.56 85.76L135.05 133.79V217.26Z",
    fill: "#FECECA"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M108.94 32.74C113.04 34.43 117.14 36.12 121.24 37.8C121.02 56.15 120.8 74.52 120.59 92.87C85.53 113.1 50.4899 133.33 15.4399 153.53V74.83C46.6099 60.8 77.7899 46.76 108.94 32.73V32.74Z",
    fill: "#F97E73"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M28.1899 81.7101V159.78L15.46 153.53V74.8301L28.1899 81.7001V81.7101Z",
    fill: "#FEE4E2"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M28.1899 159.78C59.2699 143.14 90.3499 126.53 121.43 109.89C121.36 85.85 121.29 61.81 121.24 37.78C90.23 52.41 59.1999 67.05 28.1899 81.68V159.78Z",
    fill: "#72D09A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMur1);
export default __webpack_public_path__ + "static/media/mur1.34e2ec949790a5c53e25122aa14faeb1.svg";
export { ForwardRef as ReactComponent };